<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
          <!-- <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Data vessel</h4>
              <button class="float-right btn btn-primary shadow" v-on:click="formNewvessel=!formNewvessel">vessel baru</button>
          </div>
          <div class="col-12  mt-2 py-0">
            <create-vessel @createvessel="createVesselResult" :formstate="formNewvessel" />
          </div> -->
          <div class="col-12  my-2 py-0">
            <datatable :datas="Mastervessels" :current-idx="currentIdx" @refetch="(row)=>{rowLimit=row;getMastervessels()}" :prev-url="prevUrl" :next-url="nextUrl" @change-url="(url)=>getMastervessels(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)" :structure="MastervesselTableStructure" @searching="(val)=>val.status?Mastervessels=val.data:getMastervessels()" :init="datatable.loadData" use-seeker seeker-url="/api/master/seeker/vessel">
                <!-- <template #head>
                    <th>Tindakan</th>
                </template> -->
                <template #customcell="{obj}">
                    <b-row class="shadow mx-auto mx-md-3 px-md-2 py-4 rounded bg-white mt-2">
                        <b-col cols="12" md="6" lg="3">
                            <h5><b-icon icon="triangle-fill"></b-icon> <b>{{obj?obj.name:'-'}}</b></h5>
                            <p><b-icon icon="person-square"></b-icon> <b> {{obj.client != null?obj.client.first_name:'-'}}</b></p>
                            <p><b-icon icon="person"></b-icon> {{obj.airtime.start_period | timeformat}}-{{obj.airtime.finish_date | timeformat}}</p>
                            <!-- <p v-if="obj.hardware_setup!=null&&obj.hardware_setup.serial_number&&obj.hardware_setup.serial_number.last_track">
                                <span>SIN: {{obj.hardware_setup.serial_number.last_track.sin}}</span><br>
                                <span>Status: <div class="status_track" v-bind:class="status_track(obj.hardware_setup.serial_number.last_track.last_hour)"></div></span><br>
                                <span>Alarm: <div class="status_track" v-bind:class="alarm_track(obj.hardware_setup.serial_number.last_track.sin)"></div></span> <br>
                                <span>Message: {{obj.hardware_setup.serial_number.last_track.message}}</span>
                            </p> -->
                            <div class="w-100" v-show="isMobile">
                                <hr class="my-2">
                                <h5>Transmitter</h5>
                                <small>SN.</small> <b>{{obj.hardware_setup!=null&&obj.hardware_setup.serial_number?obj.hardware_setup.serial_number.serial_number:'-' }}</b><br>
                                <small>ID.</small> <b>{{obj.hardware_setup!=null&&obj.hardware_setup.id_transmitter?obj.hardware_setup.id_transmitter:'-' }}</b><br>
                                <b>{{obj.hardware_setup!=null&&obj.hardware_setup.packet?obj.hardware_setup.packet:'-' }}</b><br>
                                <small>KKP</small><br>
                                <hr class="my-2">
                                <h4>Posisi Terbaru</h4>
                                <small>Pos.</small> <b>{{ obj.track?obj.track.longitude:'-' }}</b>, <b>{{obj.track?obj.track.latitude:'-'}}</b><br>
                                <small>Speed </small><b>{{obj.track?obj.track.speed:'-' }}</b> knot<br>
                                <small>Heading</small> <b>{{ obj.track?obj.track.heading:'-' }}</b><br>
                                -<br>
                            </div>
                        </b-col>
                        <b-col  cols="12" md="6" lg="3" v-show="!isMobile">
                            <b-card class="card-table">
                                <h4>Transmitter</h4>
                                <p>SN. {{obj.hardware_setup!=null&&obj.hardware_setup.serial_number?obj.hardware_setup.serial_number.serial_number:'-' }}</p>
                                <p>{{translatePacket(obj.hardware_setup!=null&&obj.hardware_setup.packet?obj.hardware_setup.packet:'-') }}</p>
                                <p>ID. {{obj.hardware_setup!=null&&obj.hardware_setup.id_transmitter?obj.hardware_setup.id_transmitter:'-' }}</p>
                                <p>KKP</p>
                            </b-card>
                        </b-col>
                        <b-col  cols="12" md="6" lg="3" v-show="!isMobile">
                            <b-card>
                                <h4>Posisi Terbaru</h4>
                                <p>Pos. {{ obj.track?obj.track.longitude:'-' }}, {{obj.track?obj.track.latitude:'-'}}</p>
                                <p>Speed {{obj.track?obj.track.speed:'-' }} knot</p>
                                <p>Heading {{ obj.track?obj.track.heading:'-' }}</p>
                                <p>-</p>
                            </b-card>
                        </b-col>
                        <b-col  cols="12" md="6" lg="3" v-show="!isMobile">
                            <b-card>
                                <img src="/img/ship.png" alt="" class="w-50 mx-5"/>
                                <b-button pill variant="info" class="mx-3 mt-2">{{obj.hardware_setup!=null&&obj.hardware_setup.serial_number?obj.hardware_setup.serial_number.serial_number:'-' }}</b-button>
                            </b-card>
                        </b-col>
                    </b-row>
                </template>
                <!-- <template #client="{obj}">
                    {{obj.client!=null?obj.client.first_name:'-'}}
                </template> -->
                <!-- <template #addon="{idx}">
                    <b-button v-b-modal.modal-edit-vessel class="btn btn-info mr-2" v-on:click="selectedvessel=idx">edit</b-button>
                    <button v-b-modal.modal-delete-vessel v-on:click="deleteItem(idx)" class="btn btn-danger">del</button>
                </template> -->
            </datatable>
          </div>
      </div>
    </div>
    <!-- @hide="deleteModalClose" -->
    <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-vessel" title="Konfirmasi hapus vessel" scrollable no-close-on-backdrop> 
        <b-container fluid v-if="!datatable.loadData && Mastervessels.length>0">
            <b-row class="pt-1">
              <b-col cols="12" class="my-3">
                  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
                  <ul>
                      <li>vessel: {{Mastervessels[selectedToDelete].vessel_name}}</li>
                      <li>tipe: {{Mastervessels[selectedToDelete].item}}</li>
                  </ul>
              </b-col>
               <b-col cols="12" class="my-3 text-right"  v-if="deletevesselState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="vesselDeleted">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil menghapus data.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="failDeletevessel">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal menghapus data klien.
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <button class="btn btn-danger  mr-2" v-on:click="deletevesselData">Ya, hapus</button>
            <b-button class="btn btn-secondary" @click="(!deletevesselState)?$bvModal.hide('modal-delete-vessel'):''">Tutup</b-button>
            </div>
        </template>
    </b-modal>
    <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-vessel" title="Detail informasi vessel" scrollable no-close-on-backdrop size="lg" v-if="false">
        <b-container fluid v-if="!datatable.loadData && Mastervessels.length>0">
            <b-row class="pt-1">
              <b-col cols="12" class="my-3">
                  <h4>Detail vessel</h4>
              </b-col>
              <b-row>
                <b-col cols="6">
                        <label class="d-block">Nama Kapal</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].name" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Nama Legal</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].name_legal" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Owner</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].client" />
                        <!-- <smart-search url="/api/master/seeker/pengguna" key-tag="first_name" v-on:update="(data)=>smartSearchAddClient(data)"></smart-search> -->
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Tipe Kapal</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].type_vessel" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Radio</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].radio" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">GT</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].gt" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Selar Sign</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].selar_sign" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Material</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].material" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Panjang</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].panjang" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Lebar</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].lebar" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Power Boat</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].power_boat" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Merk Mesin</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].merk_mesin" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">No Mesin</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].no_mesin" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Groos Deed</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].gross_deed" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Tahun Pembuatan</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].tahun_pembuatan" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Alamat Pembuatan</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].alamat_pembuatan" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">No Sipi</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].no_sipi" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Flag</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].flag" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Start Sipi</label>
                        <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="example-datepicker2" v-model="Mastervessels[selectedvessel].start_sipi" class="mb-2"></b-form-datepicker>
                </b-col>
                <b-col cols="6">
                        <label class="d-block">End Sipi</label>
                        <b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="example-datepicker2" v-model="Mastervessels[selectedvessel].end_sipi" class="mb-2"></b-form-datepicker>
                </b-col>
                <b-col cols="6">
                        <label class="d-block">No Registrasi RMOF</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].no_registrasi_rmof" /> 
                </b-col>
                <b-col cols="6">
                        <label class="d-block">Status</label>
                        <smart-select name="status" :options="updateStatusTypeOptions" v-on:update="(value)=>{Mastervessels[selectedvessel].status=value}"></smart-select>
                </b-col>
                <b-col cols="6">
                        <label class="d-block">User Update</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="Mastervessels[selectedvessel].user_update" /> 
                </b-col>

                <b-col cols="12" class="my-3 text-right"  v-if="editvesselState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="updatevesselSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil update data vessel.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="errorvesselSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal update data vessel.
                        </div>
                    </div>
                </div>
                <b-col cols="12" class="my-3 text-right">
                    <button class="btn btn-info" v-on:click="updatevesselData">Submit</button>
                </b-col>
            </b-row>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <b-button class="btn btn-secondary mr-2" @click="(!editvesselState)?$bvModal.hide('modal-edit-vessel'):''">Tutup</b-button>
            <!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
            </div>
        </template>
  </b-modal>

  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import CreateVessel from '../../components/CreateVessel.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'create-vessel':CreateVessel
        },
        data () {
            return {
                rowLimit:10,
                 isMobile:false,
                currentIdx:1,
                datatable:{
                    loadData:false
                },
                itemTypeOptions:[
                    {label:'Antena',value:'antena'},
                    {label:'JB',value:'jb'},
                ],
                statusTypeOptions:[
                    {label:'Aktif',value:'active'},
                    {label:'Tidak aktif',value:'inactive'},
                ],
                // newvessel:{
                //     name:'',
                //     name_legal:'',
                //     client:'',
                //     no_sipi:'',
                //     start_sipi:'',
                //     end_sipi:'',
                //     flag:'',
                //     type_vessel:'',
                //     radio:'',
                //     gt:'',
                //     selar_sign:'',
                //     material:'',
                //     panjang:'',
                //     lebar:'',
                //     power_boat:'',
                //     merk_mesin:'',
                //     no_mesin:'',
                //     gross_deed:'',
                //     tahun_pembuatan:'',
                //     alamat_pembuatan:'',
                //     no_registrasi_rmof:'',
                //     status:'active',
                //     user_update:'',
                // },
                errorvesselSaved:false,
                updatevesselSaved:false,
                editvesselState:false,
                deletevesselState:false,
                failDeletevessel:false,
                vesselDeleted:false,
                Mastervessels:[],
                errorNewvesselList:[],
                formNewvessel:false,
                errorNewvessel:false,
                savingNewvessel:false,
                newvesselSaved:false,
                searchValue:'',
                selectedToDelete:0,
                selectedvessel:0,
                MastervesselTableStructure:[
                    {label:'List Vessel Terdaftar',key:'name'},
                ]
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            console.log("vessel page")
            this.getMastervessels();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
                console.log('screen update')
                this.isMobile = screen.width < 768
            });
        },
        methods:{
            translatePacket(role){
                var label="";
                switch(role){
                    case "not_active":
                        label = "Not Active";
                        break;
                    case "test_idp690":
                        label = "MSP Plan Test IDP690";
                        break;
                    case "activation_idp690_10k_01":
                        label = "Activation IDP690 10k 01";
                        break;
                    case "activation_idp690_10k_02":
                        label = "Activation IDP690 10k 02";
                        break;
                    case "activation_idp690_10k_03":
                        label = "Activation IDP690 10k 03";
                        break;
                    case "activation_st6100_10k":
                        label = "Activation ST6100 10k";
                        break;
                    case "activation_100k":
                        label = "Activation 1001";
                        break;
                    case "blocked":
                        label = "Blocked";
                        break;
                }
                return label;
            },
            createVesselResult(data){
                console.log("create vessel finished")
                if(data.status){
                    this.getMastervessels();
                    //this.resetNewVesselData();
                }
            },
            getMastervessels(url=(this.$baseUrl+'/api/master/vessel?limit='+this.rowLimit)){
                console.log(url)
                this.datatable.loadData=true;
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.datatable.loadData=false;
                    this.prevUrl = result.data.prev_page_url
                    this.nextUrl = result.data.next_page_url
                    this.currentIdx = result.data.current_page
                    this.Mastervessels = result.data.data;
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.datatable.loadData=false;
                })
            },
            // updateNewVesselStatus(data){
            //     this.newvessel.status=data
            // },
            // updatevesselItemType(value){
            //     this.Mastervessels[this.selectedvessel].item=value;
            // },
            // updateNewvesselItemType(value){
            //     this.newvessel.itemType=value;
            // },
            status_track(last_hour){
                if (last_hour < 1) {
                    return 'track_green';
                }else if (last_hour < 3) {
                    return 'track_gray';
                }else{
                    return 'track_yellow';
                }
            },
            alarm_track(sin){
                if (sin == '0' || sin == '16') {
                    return 'track_purple';
                }else if (sin == '128' || sin == '129') {
                    return 'track_red';
                }else{
                    return 'track_black';
                }
            },
            deleteItem(idx){
                this.selectedToDelete=idx;
            },
            deletevesselData(){
              console.log('deleting data')
              this.deletevesselState=true;
              axios.delete(this.$baseUrl+'/api/master/vessel/'+this.Mastervessels[this.selectedToDelete].id,{
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                    this.deletevesselState=false;
                    this.vesselDeleted=true;
                    
                  setTimeout(() => {
                        this.Mastervessels.splice(this.selectedToDelete, 1);
                        this.$bvModal.hide('modal-delete-vessel');
                        this.vesselDeleted=false;
                  }, 1500);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.deletevesselState=false;
                this.failDeletevessel=true;
                setTimeout(() => {
                      this.failDeletevessel=false;
                  }, 1500);
                console.log(err)
              })
            },
            // deleteModalClose(mdl){
            //   if(this.deletevesselState){
            //     console.log('deleting')
            //     mdl.preventDefault()
            //   }else{
            //     console.log('closing')
            //     mdl.hide('modal-delete-user');
            //   }
            // },
            // editModalClose(mdl){
            //   if(this.editvesselState){
            //     console.log('deleting')
            //     mdl.preventDefault()
            //   }else{
            //     console.log('closing')
            //     mdl.hide('modal-delete-user');
            //   }
            // },
            // updatevesselData(){
            //     console.log('updating data')
            //   this.editvesselState=true;
            //   axios.put(this.$baseUrl+'/api/master/vessel/'+this.Mastervessels[this.selectedvessel].id,
            //   this.Mastervessels[this.selectedvessel],{
            //       'headers':{
            //           'Authorization':'Bearer '+localStorage.getItem('accessToken')
            //       }
            //   }).then((result)=>{
            //     if(result.status==200){
            //       this.editvesselState=false;
            //       this.updatevesselSaved=true;
            //       setTimeout(() => {
            //           this.updatevesselSaved=false;
            //       }, 1500);
            //       console.log('yaya berhasil')
            //     }
            //   }).catch((err)=>{
          //check if token fail
            //   if(err.response && err.response.status==401){
            //     localStorage.removeItem('accessToken')
            //   this.$router.push('/login')
            //   }
            //     this.editvesselState=false;
            //     this.errorvesselSaved=true;
            //     setTimeout(() => {
            //           this.errorvesselSaved=false;
            //       }, 1500);
            //     console.log(err)
            //   })
            // },
            
            
        },
    }
</script>
<style scoped>


.card-body {
    background-color: #002060;
    border-radius: 1.25rem;
    color:#fff;
}
.card-body p {
    margin-bottom: 0;
}
.card {
    border: 1px solid rgba(0, 0, 0, 0);
    height: 200px;
    width: 230px;
}
h4, .h4 {
    margin: 0px 0 10px;
}

.table th, .table td {
    border-top: 0 solid #dee2e6;
}
::v-deep .btn-info {
    color: #fff;
    border-color: #fff;
}
::v-deep .btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .open > .btn-info.dropdown-toggle {
    background-color: transparent;
    color: #fff;
    border-color: #fff;
}
.status_track{
    width: 12px;
    height: 12px;
    background: transparent;
    border-radius: 50px;
    display: inline-block;
}
.track_green{
    background: #75bd06;
}
.track_gray{
    background: gray;
}
.track_yellow{
    background: #FFF4A3;
}
.track_purple{
    background: purple;
}
.track_red{
    background: red;
}
.track_black{
    background: black;
}
</style>
